export enum DataScienceTaskStatus {
  SCHEDULED = 'Scheduled',
  PROCESSING = 'Processing',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  AWAITINGAPPROVAL = 'Awaiting Approval',
  APPROVED = 'Approved',
  MODELAPPROVED = 'ModelApproved',
  DISABLED = 'Disabled',
  STAGING = 'Staging'
}
